// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["blocks/marine-card-days/style-view","blocks/search-bar-marine/style-view","blocks/weather-forecast/style-view","blocks/weather-forecast-city/style-view"], () => (__webpack_require__("./src/blocks/weather-forecast-city/view.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
